// extracted by mini-css-extract-plugin
module.exports = {"planList":"PlanScreen_planList__2_4ep","button":"PlanScreen_button__3v3D2","planColumn":"PlanScreen_planColumn__3vX9q"};